import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SortIcon from '@mui/icons-material/Sort';
import PropTypes from 'prop-types';
import React from 'react';

class OrderBySelect extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div className="text-right pb-2">
        <Button
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <SortIcon /> <span className="pl-2">{this.props.selection}</span>
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem
            onClick={() => {
              this.props.handleClick({
                title: 'Rating',
                orderby: 'score',
              });
              this.handleClose();
            }}
          >
            Rating
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.props.handleClick({
                title: 'Newest',
                orderby: 'createdAt',
              });
              this.handleClose();
            }}
          >
            Newest
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.props.handleClick({
                title: 'Random',
                orderby: 'random',
              });
              this.handleClose();
            }}
          >
            Random
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

OrderBySelect.propTypes = {
  selection: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default OrderBySelect;
